import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['destination', 'card', 'investForm', 'consultForm']

  refresh() {
    this.cardTargets.forEach((card) => {
      const selected = card.querySelector('input[type="radio"]').checked

      card.classList.toggle('bg-primary-50', selected)
      card.classList.toggle('border-primary-600', selected)
      card.classList.toggle('bg-white', !selected)
      card.classList.toggle('border-gray-300', !selected)

      const icon = card.querySelector('[data-role="icon"]')
      icon.classList.toggle('bg-primary-100', selected)
      icon.classList.toggle('bg-gray-100', !selected)

      const glyph = icon.querySelector('svg')
      glyph.classList.toggle('text-primary-600', selected)
      glyph.classList.toggle('text-gray-500', !selected)
    })
  }

  continue() {
    const destination = this.#selectedDestination()
    if (!destination) return

    if (destination === 'consult' && this.hasConsultFormTarget) {
      this.consultFormTarget.requestSubmit()
    } else {
      this.investFormTarget.requestSubmit()
    }
  }

  #selectedDestination() {
    const checked = this.destinationTargets.find((radio) => radio.checked)

    return checked ? checked.value : null
  }
}
